import { NavigationEnd, Router } from '@angular/router';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { Constant } from 'src/app/constant/constant';
import { EmailSendService } from 'src/app/services/email-send.service';
import { LoaderService } from 'src/app/services/loader.service';
import { SendEmailService } from 'src/app/services/send-email.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';

import { environment } from 'src/environments/environment';

import { TemplateServiceService } from 'src/app/services/template-service.service';
import { TemplateConfirmPopupComponent } from '../email-popup-component/template-confirm-popup/template-confirm-popup.component';
import { SendSmsService } from 'src/app/services/send-sms.service';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';
import { PhoneNumbersService } from 'src/app/services/phone-numbers.service';

@Component({
  selector: 'calsoft-send-sms-popup',
  templateUrl: './send-sms-popup.component.html',
  styleUrls: ['./send-sms-popup.component.scss']
})
export class SendSmsPopupComponent implements OnInit, OnDestroy {

  url = '';

  sanitizedUrl = '';

  protected _onDestroy = new Subject<void>();

  data: any;

  firstFormGroup: UntypedFormGroup;

  text: string;

  type: any = 1;

  constructor(private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private sendSmsService: SendSmsService,
    private ecryptService: EcryptServiceService,
    private phoneNumbersService: PhoneNumbersService,
    @Inject(MAT_DIALOG_DATA) data, private router: Router
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });
    this.data = data;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }



  ngOnInit() {

    this.initForm();

    this.getPhoneNumberList();

    this.PhoneNoYFilter();

    this.text = "Send";

    this.firstFormGroup.patchValue({
      to: this.data.phone,
      leadId: this.data.leadId
    });

  }


  initForm() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      body: [""],
      type: [''],
      From: [''],
      to: [''],
      leadId: [''],
      accountSid: [''],
      authToken: [''],
    });
  }

  filteredConfigData: any;


  sendSms() {

    if (this.text == 'Send' && this.firstFormGroup.valid) {
      this.text = "Processing";

      const formValue = this.firstFormGroup.value;

      this.sendSmsService.smsSend(formValue).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
            this.text = "Send";
            this.dialog.closeAll();
          }
          else {
            this.text = "Send";
            this.dialog.closeAll();
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        () => {
          this.dialog.closeAll();
          this.text = "Send"
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  close() {
    this.dialog.closeAll();
  }


  setPhoneNoSelection(event, values) {

    console.log("values", values);

    if (event.isUserInput != false) {
      this.firstFormGroup.patchValue({
        accountSid: values.accountSid,
        authToken: values.authToken
      });
    }

  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  //AssignUsers

  phoneNoList: any;
  phoneNoTypeList: any = [];
  filteredphoneNoTypeList: any = [];
  phoneNoControl: UntypedFormControl = new UntypedFormControl();
  phoneNoFilterControl: UntypedFormControl = new UntypedFormControl();

  getPhoneNumberList() {
    this.phoneNumbersService.getAllDropDown().subscribe(
      data => {
        this.phoneNoList = data;
        this.phoneNoTypeList = data;
        this.filteredphoneNoTypeList = this.phoneNoTypeList;
      }
    )
  }



  PhoneNoYFilter() {
    this.phoneNoFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.phoneNoFilter();
      });
  }

  protected phoneNoFilter() {
    if (!this.phoneNoTypeList) {
      return;
    }
    // get the search keyword
    let search = this.phoneNoFilterControl.value;
    if (!search) {
      this.filteredphoneNoTypeList = this.phoneNoTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredphoneNoTypeList = this.phoneNoTypeList.filter(phone => phone['phoneNumber'].toLowerCase().indexOf(search) > -1)
  }

}
